module.exports = __webpack_public_path__ + "media/assets/images/cart-630af4013de8bee3772278ebf075f334.svg";